import B from "../../@babel/runtime/helpers/esm/extends.mjs";
import s from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import G from "../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import J from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import * as n from "react";
import Q from "./useForm.mjs";
import U, { HOOK_MARK as X } from "./FieldContext.mjs";
import Y from "./FormContext.mjs";
import { isSimilar as Z } from "./utils/valueUtil.mjs";
import _ from "./ListContext.mjs";
var ee = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed", "clearOnDestroy"], ce = function(e, y) {
  var l = e.name, I = e.initialValues, u = e.fields, S = e.form, T = e.preserve, c = e.children, p = e.component, F = p === void 0 ? "form" : p, D = e.validateMessages, h = e.validateTrigger, C = h === void 0 ? "onChange" : h, O = e.onValuesChange, R = e.onFieldsChange, V = e.onFinish, H = e.onFinishFailed, A = e.clearOnDestroy, d = J(e, ee), b = n.useRef(null), i = n.useContext(Y), $ = Q(S), j = G($, 1), r = j[0], a = r.getInternalHooks(X), w = a.useSubscribe, K = a.setInitialValues, N = a.setCallbacks, k = a.setValidateMessages, L = a.setPreserve, W = a.destroyForm;
  n.useImperativeHandle(y, function() {
    return s(s({}, r), {}, {
      nativeElement: b.current
    });
  }), n.useEffect(function() {
    return i.registerForm(l, r), function() {
      i.unregisterForm(l);
    };
  }, [i, r, l]), k(s(s({}, i.validateMessages), D)), N({
    onValuesChange: O,
    onFieldsChange: function(t) {
      if (i.triggerFormChange(l, t), R) {
        for (var o = arguments.length, M = new Array(o > 1 ? o - 1 : 0), m = 1; m < o; m++)
          M[m - 1] = arguments[m];
        R.apply(void 0, [t].concat(M));
      }
    },
    onFinish: function(t) {
      i.triggerFormFinish(l, t), V && V(t);
    },
    onFinishFailed: H
  }), L(T);
  var f = n.useRef(null);
  K(I, !f.current), f.current || (f.current = !0), n.useEffect(
    function() {
      return function() {
        return W(A);
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var v, x = typeof c == "function";
  if (x) {
    var q = r.getFieldsValue(!0);
    v = c(q, r);
  } else
    v = c;
  w(!x);
  var P = n.useRef();
  n.useEffect(function() {
    Z(P.current || [], u || []) || r.setFields(u || []), P.current = u;
  }, [u, r]);
  var z = n.useMemo(function() {
    return s(s({}, r), {}, {
      validateTrigger: C
    });
  }, [r, C]), E = /* @__PURE__ */ n.createElement(_.Provider, {
    value: null
  }, /* @__PURE__ */ n.createElement(U.Provider, {
    value: z
  }, v));
  return F === !1 ? E : /* @__PURE__ */ n.createElement(F, B({}, d, {
    ref: b,
    onSubmit: function(t) {
      t.preventDefault(), t.stopPropagation(), r.submit();
    },
    onReset: function(t) {
      var o;
      t.preventDefault(), r.resetFields(), (o = d.onReset) === null || o === void 0 || o.call(d, t);
    }
  }), E);
};
export {
  ce as default
};
//# sourceMappingURL=Form.mjs.map
